/**
 * Created by neo on 12.04.22.
 */
import { makeAutoObservable, onBecomeObserved, runInAction, toJS } from 'mobx';
import { v4 as UUID } from 'uuid';
import { LocalizedEntity, createLocalizedEntity } from '../../../LocalizedEntity';
import { TimeOfDay } from '../../../TimeOfDay';
import { Media, createMedia, getMediaSmallest, getMediaMediumOrSmallest, getMediaLargeOrMediumOrSmallest } from '../../../Media/Media';
import { Activity, ActivityApi } from '../../../Activity/Activity';
import { MindfulnessProgram } from '../MindfulnessProgram';

export type MindfulnessProgramTemplateDayUnit = LocalizedEntity & {
  type: string;
  activityIdentifier: string;
  includedTags: string[];
  excludedTags: string[];
  image?: Media;
  durationInMinutes: number;
  timeOfDay: TimeOfDay;
  activity?: Activity;
  program?: MindfulnessProgram;
  readonly smallestImage: any;
  readonly mediumImage: any;
  readonly largeImage: any;
  readonly defaultImage: any;
};

export function createMindfulnessProgramTemplateDayUnit(
  json?: Partial<MindfulnessProgramTemplateDayUnit>,
): MindfulnessProgramTemplateDayUnit {
  const unit: MindfulnessProgramTemplateDayUnit = makeAutoObservable({
    ...createLocalizedEntity(json as any),
    type: json?.type ?? 'default',
    activityIdentifier: json?.activityIdentifier ?? '',
    includedTags: json?.includedTags ?? [],
    excludedTags: json?.excludedTags ?? [],
    image: json?.image ? createMedia(json.image as any) : undefined,
    durationInMinutes: json?.durationInMinutes ?? 0,
    timeOfDay: json?.timeOfDay ?? 'any',
    activity: undefined as Activity | undefined,
    program: undefined as MindfulnessProgram | undefined,

    get smallestImage(): any {
      const mediaUrl = this.image ? getMediaSmallest(this.image) : null;
      return mediaUrl ? { uri: mediaUrl } : this.defaultImage;
    },

    get mediumImage(): any {
      const mediaUrl = this.image ? getMediaMediumOrSmallest(this.image) : null;
      return mediaUrl ? { uri: mediaUrl } : this.defaultImage;
    },

    get largeImage(): any {
      const mediaUrl = this.image ? getMediaLargeOrMediumOrSmallest(this.image) : null;
      return mediaUrl ? { uri: mediaUrl } : this.defaultImage;
    },

    get defaultImage(): any {
      return undefined;
    },
  });

  onBecomeObserved(unit, 'activity', () => {
    if (!unit.activity) {
      ActivityApi.get(unit.activityIdentifier).then((result) => runInAction(() => (unit.activity = result)));
    }
  });

  return unit;
}
